"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (response) {
    var x = [
        { key: 'half_damage_from', multiplier: 0.5, direction: 'from' },
        { key: 'no_damage_from', multiplier: 0, direction: 'from' },
        { key: 'half_damage_to', multiplier: 0.5, direction: 'to' },
        { key: 'double_damage_from', multiplier: 2, direction: 'from' },
        { key: 'no_damage_to', multiplier: 0, direction: 'to' },
        { key: 'double_damage_to', multiplier: 2, direction: 'to' },
    ];
    return x.reduce(function (acc, curr) {
        var nodes = response.damage_relations[curr.key].map(function (relation) {
            return {
                name: relation.name,
                multiplier: curr.multiplier,
                direction: curr.direction,
            };
        });
        return acc.concat(nodes);
    }, []);
});
//# sourceMappingURL=type_to_nodes.js.map